<template lang="pug">
  v-dialog(v-model='isTransaction'  persistent='' width='300' transition='dialog-bottom-transition')
    v-card(color='primary' dark='')
      v-card-text.pa-4
        small.font-size-12.font-weight-700 {{label}}
        v-progress-linear.ma-1(:value='value' color='white')
        .d-flex
          v-spacer
          small.font-size-11 se cancelará automaticamente en {{timer}} seg.
        .d-flex.mt-4(v-if="Math.sign(timer) === -1")
          v-btn(color="white primary--text", :small="!isMovil" block, @click="reloadPage")
            | Recargar pagina
</template>
<script>
export default {
  props : {
    label : {
      type   : String,
      default: 'Transacción en curso'
    }
  },
  data () {
    return {
      isTransaction: true,
      interval     : {},
      value        : 0,
      timer        : 20
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  beforeDestroy () {
    var vm = this
    clearInterval(vm.interval)
  },
  mounted () {
    var vm = this
    vm.interval = setInterval(() => {
      if (vm.value === 100) {
        return (vm.value = 0)
      }
      vm.value += 5
      vm.timer -= 1
    }, 1000)
  },
  methods  : {
    reloadPage () {
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_loading_transaction.vue?0dea45b1